import { render, staticRenderFns } from "./ModuleSetRecord.vue?vue&type=template&id=327c4285&scoped=true&lang=pug&"
import script from "./ModuleSetRecord.vue?vue&type=script&lang=js&"
export * from "./ModuleSetRecord.vue?vue&type=script&lang=js&"
import style0 from "./ModuleSetRecord.vue?vue&type=style&index=0&id=327c4285&lang=scss&scoped=true&"
import style1 from "./ModuleSetRecord.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "327c4285",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VTextField } from 'vuetify/lib/components/VTextField';
import { VTextarea } from 'vuetify/lib/components/VTextarea';
installComponents(component, {VIcon,VTextField,VTextarea})
